import React from 'react'
import TimeLineP from '../common/Calender_Project'
import './style.css'

const TimeLine = () => {
  return (
    <div className='time__line'>
      <TimeLineP />
    </div>
  )
}

export default TimeLine
